// MSAL 2 reads the callback hash from its popup/iframe. Starting our router in
// that window would navigate to /auth/login and discard the response first.
export function isMicrosoftAuthCallback(target) {
  if (!target.opener && target.parent === target) return false;
  const params = new URLSearchParams(target.location.hash.replace(/^#/, ''));
  return params.has('state') && ['code', 'error', 'id_token', 'access_token'].some(key => params.has(key));
}
